import { render, staticRenderFns } from "./grayDevice.vue?vue&type=template&id=4896303c&scoped=true"
import script from "./grayDevice.vue?vue&type=script&lang=js"
export * from "./grayDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896303c",
  null
  
)

export default component.exports